const SOPOView = ({ errors }) => {
  if (!errors || errors.length === 0) return null;

  return (
    <div className="card">
      <h5 className="text-red-600">
        ⚠️ AB Sales Order / INC Purchase Order Conflict Detected
      </h5>

      <div className="space-y-2 mt-2">
        {errors.map((error, index) => (
          <div key={index}>{error}</div>
        ))}
      </div>
    </div>
  );
};

export default SOPOView;
